import React, { useState } from "react";
import "./FeedbackTest.scss";
import InnerNav from "../../components/InnerNav/InnerNav";
import Footer from "../../components/Footer/Footer";
import AdminNav from "../AdminNav/AdminNav";

const FeedbackTestimonial = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const testimonials = [
    {
      id: 1,
      name: "Alice Johnson",
      role: "Software Engineer",
      feedback:
        "This platform is absolutely amazing! The experience has been smooth and very insightful.",
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      role: "Entrepreneur",
      feedback:
        "I found the guidance extremely helpful. Highly recommend to anyone seeking clarity!",
    },
    {
      id: 3,
      name: "Maria Lopez",
      role: "Designer",
      feedback:
        "Very professional and detailed. The service exceeded my expectations.",
    },
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Feedback submitted successfully!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="feedback-testimonial-container">
        <AdminNav/>
        <div className="feedback-testimonial-content">
      {/* Feedback Form */}
      <section className="feedback-section">
        <h2>We Value Your Feedback</h2>
        <p>Let us know your thoughts and suggestions.</p>
        <form onSubmit={handleSubmit} className="feedback-form">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Write your feedback..."
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Submit Feedback</button>
        </form>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <h2>What People Say</h2>
        <div className="testimonial-grid">
          {testimonials.map((t) => (
            <div key={t.id} className="testimonial-card">
              <p className="feedback">“{t.feedback}”</p>
              <h4>{t.name}</h4>
              <span>{t.role}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
    </div>
  );
};

export default FeedbackTestimonial;
